{
  "fr": {
    "profile": {
      "subNav": {
        "general": "Mon profil",
        "account": "Modifier le compte",
        "privacy": "Confidentialité",
        "licenses": "Mes licences",
        "emailSettings": "Paramètres de l'e-mail",
        "authorizedApplications": "Connexions partenaires",
        "export": "Exportation de données"
      },
      "general": {
        "title": "Profil",
        "sectionName": "Nom",
        "sectionLocality": "Profession & École",
        "sectionCommunity": "Communauté",
        "sectionSettings": "Paramètres",
        "nameHint": "Nous avons besoin de ces informations pour l'attestation de participation.",
        "nameHintInternational": "Votre nom complet est utilisé uniquement lorsque vous participez à l'une de nos formations pour que nous puissions vous délivrer une attestation officielle.",
        "localityHint": "Améliorez vos recommandations personnelles en ajoutant plus d'informations (facultatif).",
        "localityHintInternational": "Avec les informations suivantes, vous nous aidez à vous offrir la meilleure expérience possible :",
        "communityHint": "Ces informations sont facultatives et seront utilisées dans notre galerie de matériel pédagogique.",
        "firstname": "Prénom",
        "lastname": "Nom de famille",
        "job": "Profession",
        "customJob": "Autre profession",
        "schoolType": "Type d'école",
        "schoolTypeCustom": "Autre type d'école",
        "country": "Pays",
        "region": "État fédéré",
        "regionCanton": "Canton",
        "regionNoCountry": "Choisissez d'abord un pays.",
        "fromSchool": "Vient de ton école.",
        "gradeList": "Niveaux de classe",
        "subjectList": "Matières",
        "customSubject": "Autre matière",
        "avatar": "Photo de profil",
        "avatarHelp": "200x200 pixels recommandé",
        "avatarUploadError": "La photo de profil n'a pas pu être téléchargée.",
        "avatarUploadProgress": "Image de profil en cours de téléchargement",
        "communityName": "Nom de la communauté",
        "communityNameHelp": "Si vous souhaitez utiliser un autre nom pour partager des matériaux, vous pouvez le saisir ici. Sinon, nous utiliserons votre prénom et nom.",
        "timezone": "Fuseau horaire",
        "timeFormat": "Format de l'heure",
        "locale": "Langue de l'interface utilisateur",
        "timeFormatOptions": {
          "TWELVE_HOURS": "12 heures",
          "TWENTY_FOUR_HOURS": "24 heures"
        },
        "jobOptions": {
          "JOB_TEACHER": "Enseignant·e",
          "JOB_LEADING_TEACHER": "Responsable de matière",
          "JOB_PRINCIPAL": "Direction d'école",
          "JOB_UNIVERSITY_STUDENT": "Étudiant·e",
          "JOB_TEACHER_TRAINEE": "Stagiaire enseignant·e",
          "JOB_PARENT": "Parent",
          "JOB_SOCIAL_WORKER": "Éducateur·trice social·e",
          "JOB_FACULTY_MEMBER": "Enseignant·e universitaire",
          "JOB_ADMINISTRATIVE_STAFF": "Personnel administratif",
          "JOB_OTHER": "Autre"
        },
        "selectPlaceholder": "Veuillez sélectionner",
        "privacyDeletionNotice": "Avis de confidentialité : Si votre compte reste inactif pendant plus de deux ans, nous vous informerons par e-mail de la suppression automatique prévue. Si vous ne le réactivez pas dans le mois suivant la notification, il sera automatiquement supprimé.",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "deleteAccount": "Supprimer le compte",
        "deleteAccountDescription": "La suppression de votre compte est irréversible. Toutes vos données seront supprimées.",
        "deleteAccountConfirmation": "Êtes-vous sûr de vouloir supprimer votre compte ?",
        "deleteAccountButton": "Supprimer le compte de manière irréversible",
        "successMessage": "Profil mis à jour avec succès.",
        "errorMessage": "Le profil n'a pas pu être mis à jour."
      },
      "account": {
        "title": "Modifier le compte",
        "email": "E-mail",
        "password": "Nouveau mot de passe",
        "passwordHelp": "Laisser vide si vous ne souhaitez pas le changer.",
        "currentPassword": "Mot de passe actuel",
        "currentPasswordHelp": "Nous avons besoin de votre mot de passe actuel pour confirmer les modifications.",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "invoiceEmailNotice": "Pour modifier votre e-mail de facturation, veuillez visiter la <a href=\"{portalUrl}\">gestion des abonnements</a>.",
        "unconfirmedEmail": "Nous avons envoyé un e-mail de confirmation à votre nouvelle adresse. Veuillez le confirmer.",
        "oauthConnected": "Connecté avec",
        "oauthConnect": "Connectez votre compte fobizz",
        "connectButton": "Connecter avec {provider}",
        "disconnect": "Dissocier",
        "fobizzId": "ID fobizz",
        "successMessage": "Compte mis à jour avec succès.",
        "errorMessage": "Le compte n'a pas pu être mis à jour."
      },
      "disconnectOauth": {
        "title": "Dissocier de {provider}",
        "hint": "Veuillez choisir un mot de passe pour vous connecter après la dissociation.",
        "password": "Nouveau mot de passe",
        "submit": "Dissocier",
        "cancel": "Annuler",
        "successMessage": "La connexion a été dissociée avec succès.",
        "errorMessage": "La connexion n'a pas pu être dissociée."
      },
      "privacy": {
        "title": "Paramètres de confidentialité",
        "embedConsent": {
          "paragraph": "Vous acceptez que les contenus vidéo dans les formations soient chargés et que les données nécessaires, notamment votre adresse IP, soient transmises au fournisseur. Avec ce consentement, il est possible de regarder les vidéos dans les formations. Pour plus d'informations, consultez notre politique de confidentialité.",
          "agree": "Donner son consentement",
          "disagree": "Révoquer le consentement"
        }
      },
      "licenses": {
        "title": "Mes licences",
        "sectionSubscriptions": "Abonnements et licences individuelles",
        "subtitleSubscriptions": "Vous avez réservé les licences individuelles suivantes :",
        "sectionMemberships": "Adhésions à des groupes de licences",
        "subtitleMembershipsWithGroups": "Les groupes de licences suivants vous donnent droit à l'utilisation des différentes offres :",
        "manageSubscription": "Gérer l'abonnement",
        "portalError": "Le portail d'abonnement n'a pas pu être ouvert pour le moment.",
        "buyNow": "Acheter maintenant",
        "activatedAt": "Activé le",
        "nextBilling": "Prochain paiement",
        "billingPeriod": "Période de paiement",
        "billingPeriodUnits": {
          "year": "Annuel",
          "month": "Mensuel"
        },
        "paused": "En pause",
        "resumed": "Repris",
        "cancelledAt": "Terminé le",
        "usageUntil": "Utilisable jusqu'à",
        "price": "Prix",
        "statusExpired": "Expiré",
        "statuses": {
          "ACTIVE": "Actif",
          "IN_TRIAL": "Essai",
          "NON_RENEWING": "Expire",
          "PAUSED": "En pause",
          "CANCELLED": "Résilié",
          "FUTURE": "À venir"
        },
        "planTitles": {
          "combined": "Forfait formations + outils",
          "courses": "Forfait formations",
          "tools": "Forfait outils"
        },
        "planDescriptions": {
          "combined": "Accès illimité à toutes les formations fobizz, outils fobizz et assistance IA pour l'enseignement.",
          "courses": "Accès illimité à toutes les formations fobizz.",
          "tools": "Accès illimité aux outils fobizz et à l'assistance IA pour l'enseignement."
        },
        "offerHeading": "Ton abonnement fobizz flexible",
        "offerDescription": "Envie de te former à tout moment ou d'utiliser les outils et l'IA fobizz sans limite ? Découvre toutes les offres fobizz.",
        "offerButton": "Comparer les offres",
        "offerHint": "Veuillez noter : En raison des réglementations sur la TVA, nous ne pouvons actuellement pas proposer de licences à des <strong>utilisateurs individuels</strong> dans des pays en dehors de l'Union européenne et de la Suisse. Cependant, nous proposons des licences pour les écoles et les établissements d'enseignement <strong>dans tous les pays</strong>.",
        "noSubscription": "Vous n'avez actuellement aucun abonnement actif."
      },
      "emailSettings": {
        "title": "Paramètres de l'e-mail",
        "subheading": "Notifications par e-mail",
        "labelCourses": "Informations sur les nouveaux cours, webinaires en direct, promotions et actions scolaires (recommandé)",
        "frequency": "Fréquence de la newsletter",
        "frequencyOptions": {
          "WEEKLY": "Hebdomadaire",
          "NEVER": "Jamais"
        },
        "save": "Enregistrer",
        "successMessage": "Paramètres de l'e-mail mis à jour.",
        "errorMessage": "Les paramètres de l'e-mail n'ont pas pu être mis à jour."
      },
      "authorizedApplications": {
        "title": "Connexions partenaires",
        "hint": "Ces applications partenaires sont connectées à ton compte fobizz. Voir les <a href=\"https://app.fobizz.com/en/partners\" class=\"text-decoration-underline\">partenaires</a>.",
        "application": "Application",
        "createdAt": "Connecté depuis",
        "revoke": "Révoquer",
        "revokeConfirmation": "Es-tu sûr ?",
        "noApplications": "Aucune application autorisée."
      },
      "export": {
        "title": "Exportation de données",
        "description": "Ici, tu peux télécharger toutes tes données. L'exportation est fournie sous forme de fichier ZIP et contient toutes tes données au format JSON ainsi que tous les fichiers téléchargés.",
        "buttonCreate": "Exporter les données",
        "buttonDownload": "Télécharger l'exportation de données",
        "confirmCreate": "Souhaites-tu lancer une exportation de données ?",
        "processing": "Une exportation de données est en cours. Cela peut prendre plusieurs heures pour la générer. Tu seras notifié par e-mail dès qu'elle sera prête.",
        "availableUntil": "L'exportation est disponible pendant 3 jours, puis sera supprimée."
      }
    }
  }
}
